import { createAction, createReducer } from 'utils/reducer/utils.reducer';

// Local constants
const PATH = 'users/';
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CONTROLS_CHANGED = `${PATH}CONTROLS_CHANGED`;
const FORM_CONTROLS_CHANGED = `${PATH}FORM_CONTROLS_CHANGED`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const FILTERS_CHANGED = `${PATH}FILTERS_CHANGED`;
const APPLY_FILTER = `${PATH}APPLY_FILTER`;
const CLEAR_FILTER = `${PATH}CLEAR_FILTER`;
const PAGINATION_CHANGED = `${PATH}PAGINATION_CHANGED`;

// Global constants for saga
export const USERS = {
  RESET: `${PATH}RESET`,
  INITIAL_QUERY_SUCCESS: `${PATH}INITIAL_QUERY_SUCCESS`,
  INITIAL_QUERY_FAIL: `${PATH}INITIAL_QUERY_FAIL`,
  INITIAL_QUERY: `${PATH}INITIAL_QUERY`,
  DELETE_USER_SUCCESS: `${PATH}DELETE_USER_SUCCESS`,
  DELETE_USER_FAIL: `${PATH}DELETE_USER_FAIL`,
  DELETE_USER: `${PATH}DELETE_USER`,
  ROLE_ASSIGMENT_SUCCESS: `${PATH}ROLE_ASSIGMENT_SUCCESS`,
  ROLE_ASSIGMENT_FAIL: `${PATH}ROLE_ASSIGMENT_FAIL`,
  ROLE_ASSIGMENT: `${PATH}ROLE_ASSIGMENT`,
  SAVE_SELLER_SUCCESS: `${PATH}SAVE_SELLER_SUCCESS`,
  SAVE_SELLER_FAIL: `${PATH}SAVE_SELLER_FAIL`,
  SAVE_SELLER: `${PATH}SAVE_SELLER`,
  RESET_PASSWORD_MAIL: `${PATH}RESET_PASSWORD_MAIL`,
  RESET_PASSWORD_MAIL_SUCCESS: `${PATH}RESET_PASSWORD_MAIL_SUCCESS`,
  HANDLE_ENABLE_USER: `${PATH}HANDLE_ENABLE_USER`,
  HANDLE_ENABLE_USER_SUCCESS: `${PATH}HANDLE_ENABLE_USER_SUCCESS`,
  HANDLE_ENABLE_USER_FAIL: `${PATH}HANDLE_ENABLE_USER_FAIL`,
  RESET_PASSWORD_LINK: `${PATH}RESET_PASSWORD_LINK`,
  RESET_PASSWORD_LINK_SUCCESS: `${PATH}RESET_PASSWORD_LINK_SUCCESS`,
  RESET_PASSWORD_LINK_FAIL: `${PATH}RESET_PASSWORD_LINK_FAIL`,
  TOGGLE_RESET_LINK_DIALOG: `${PATH}TOGGLE_RESET_LINK_DIALOG`,
  TOGGLE_ADJUDICATIONS_DIALOG: `${PATH}TOGGLE_ADJUDICATIONS_DIALOG`,
  GET_USER_ADJUDICATIONS: `${PATH}GET_USER_ADJUDICATIONS`,
  GET_USER_ADJUDICATIONS_SUCCESS: `${PATH}GET_USER_ADJUDICATIONS_SUCCESS`,
  GET_USER_ADJUDICATIONS_FAIL: `${PATH}GET_USER_ADJUDICATIONS_FAIL`,
};

// actions
export const usersActions = {
  paginationChanged: createAction(PAGINATION_CHANGED, 'options'),
  reset: createAction(USERS.RESET),
  filtersChanged: createAction(FILTERS_CHANGED, 'filters'),
  applyFilter: createAction(APPLY_FILTER),
  clearFilter: createAction(CLEAR_FILTER),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  toggleDelete: createAction(TOGGLE_DELETE),
  controlsChanged: createAction(CONTROLS_CHANGED, 'controls', 'invalidControls'),
  formControlsChanged: createAction(FORM_CONTROLS_CHANGED, 'controls'),
  // get state
  initialQuerySuccess: createAction(USERS.INITIAL_QUERY_SUCCESS, 'payload'),
  initialQueryFail: createAction(USERS.INITIAL_QUERY_FAIL, 'payload'),
  initialQuery: createAction(USERS.INITIAL_QUERY, 'filters', 'pagination'),
  // delete
  deleteUserSuccess: createAction(USERS.DELETE_USER_SUCCESS, 'payload'),
  deleteUserFail: createAction(USERS.DELETE_USER_FAIL, 'payload'),
  deleteUser: createAction(USERS.DELETE_USER, 'controls'),
  // assigment role
  roleAssigmentSuccess: createAction(USERS.ROLE_ASSIGMENT_SUCCESS, 'payload'),
  roleAssigmentFail: createAction(USERS.ROLE_ASSIGMENT_FAIL, 'payload'),
  roleAssigment: createAction(USERS.ROLE_ASSIGMENT, 'userId', 'controls'),
  // save seller
  saveSellerSuccess: createAction(USERS.SAVE_SELLER_SUCCESS, 'payload'),
  saveSellerFail: createAction(USERS.SAVE_SELLER_FAIL, 'payload'),
  saveSeller: createAction(USERS.SAVE_SELLER, 'userId', 'controls'),
  // user
  resetPasswordMail: createAction(USERS.RESET_PASSWORD_MAIL, 'email'),
  resetPasswordMailSuccess: createAction(USERS.RESET_PASSWORD_MAIL_SUCCESS),
};

const initialState = {
  controls: {
    doQuery: true,
    roleAssigmentOpen: false,
    sellerFormOpen: false,
    anchorEl: null,
    loading: 0,
    role: null,
    user: null,
    seller: '',
    name: '',
    usersCount: 0,
    deleteIsOpen: false,
    resetPath: '',
    displayAdjudications: false,
    loadingAdjudications: true,
  },
  formControls: {
    roleId: '-1',
    areaId: '-1',
    name: '',
    taxNumber: '',
  },
  filters: {
    roleId: '-1',
    userSearch: '',
    sellerSearch: '',
    ids: [],
    registerDate: null,
    auctionAmount: '',
    adjudicationAmount: '',
    usersSync: false,
    orderSort: '-1',
  },
  pagination: {
    page: 0,
    count: 10,
  },
};

const users = createReducer(initialState, {
  [TOGGLE_FORM](state, action) {
    const seller = state.controls.user && state.controls.user.person().seller();
    state.controls[action.modal] = !state.controls[action.modal];
    state.formControls.name = seller && seller.name;
    state.formControls.taxNumber = seller && seller.taxNumber;
    state.formControls.roleId = state.controls.user?.roleId ?? '-1';
    state.formControls.areaId = state.controls.user?.areaId ?? '-1';
    state.controls.anchorEl = null;
  },
  [CONTROLS_CHANGED](state, action) {
    state.controls = {
      ...state.controls,
      ...action.controls,
    };
  },
  [FORM_CONTROLS_CHANGED](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
  },
  [TOGGLE_DELETE](state) {
    state.controls.deleteIsOpen = !state.controls.deleteIsOpen;
    state.controls.anchorEl = null;
  },
  [USERS.ROLE_ASSIGMENT](state) {
    state.controls.loading = true;
  },
  [USERS.ROLE_ASSIGMENT_SUCCESS](state) {
    state.formControls.roleId = null;
    state.controls = initialState.controls;
  },
  [USERS.SAVE_SELLER](state) {
    state.controls.loading = true;
  },
  [USERS.SAVE_SELLER_SUCCESS](state) {
    state.formControls = initialState.formControls;
    state.controls = initialState.controls;
  },
  [USERS.DELETE_USER_SUCCESS](state) {
    state.controls = initialState.controls;
  },
  [USERS.INITIAL_QUERY](state) {
    state.controls.doQuery = false;
  },
  [USERS.INITIAL_QUERY_SUCCESS](state, action) {
    state.filters.ids = action.payload.ids.users;
    state.controls.usersCount = action.payload.count.users;
  },
  [PAGINATION_CHANGED](state, action) {
    if (action.options.page) {
      state.pagination.page = action.options.page;
    }
    if (action.options.count) {
      state.pagination.count = action.options.count;
    }
  },
  [APPLY_FILTER](state) {
    state.pagination.page = 0;
    state.controls.doQuery = true;
  },
  [CLEAR_FILTER](state) {
    state.filters = initialState.filters;
    state.pagination = initialState.pagination;
    state.controls.doQuery = true;
  },
  [USERS.RESET](state) {
    state.controls = initialState.controls;
    state.filters = initialState.filters;
    state.pagination = initialState.pagination;
    state.formControls = initialState.formControls;
  },
  [FILTERS_CHANGED](state, action) {
    state.filters = { ...state.filters, ...action.filters };
  },
  [USERS.RESET_PASSWORD_MAIL_SUCCESS](state) {
    state.controls.anchorEl = null;
  },
  [USERS.TOGGLE_RESET_LINK_DIALOG](state, action) {
    state.controls.resetPath = action.payload.path;
  },
  [USERS.TOGGLE_ADJUDICATIONS_DIALOG](state) {
    state.controls.displayAdjudications = !state.controls.displayAdjudications;
  },
  [USERS.GET_USER_ADJUDICATIONS](state) {
    state.controls.loadingAdjudications = true;
  },
  [USERS.GET_USER_ADJUDICATIONS_SUCCESS](state) {
    state.controls.loadingAdjudications = false;
  },
  [USERS.GET_USER_ADJUDICATIONS_FAIL](state) {
    state.controls.loadingAdjudications = false;
  },
});

export default users;
